import {
  LINK_POCKETS,
  LINK_PRICES,
  LINK_RENT_FAST,
  LINK_SELL_FAST,
  LINK_SELL_N_RENT,
  PLACE_AD,
} from 'shared/constants/links';
import { ERowType, TQuestion } from 'shared/types/questions';

export const QUESTIONS_FOR_SALES_AND_RENTS: TQuestion[] = [
  {
    id: 1,
    question: 'Сколько стоит публикация объявления о продаже?',
    answer: [
      {
        type: ERowType.String,
        text: 'Бесплатно — первые публикации в каждой новой категории, кроме коммерческой: продажа квартиры, продажа дома и т.д. Проверьте условия для своего региона в разделе',
      },
      {
        type: ERowType.Link,
        url: LINK_PRICES,
        text: '«Прайс»',
      },
    ],
  },
  {
    id: 2,
    question: 'Сколько стоит публикация объявления об аренде?',
    answer: [
      {
        type: ERowType.String,
        text: 'Бесплатно — во всех городах',
      },
    ],
  },
  {
    id: 3,
    question: 'Что вообще я могу продать или сдать?',
    answer: [
      {
        type: ERowType.String,
        text: 'Продать можно любую недвижимость: квартиру во вторичке и новостройке, комнату, спальное место, долю в квартире, дом, часть дома, коттедж, дачу, таунхаус, участок, гараж. Можно сдавать квартиры и дома в аренду надолго и посуточно.',
      },
    ],
  },
  {
    id: 4,
    question: 'Зачем мне размещаться на Циан, если я уже разместился на другой площадке?',
    answer: [
      {
        type: ERowType.String,
        text: 'Чтобы продать или сдать недвижимость быстрее и дороже. У каждой площадки своя уникальная аудитория. А на Циан ищут недвижимость больше 19 млн человек каждый месяц: шансы найти того самого покупателя или жильца гораздо выше.',
      },
    ],
  },
  {
    id: 5,
    question: 'Как быстро я могу продать или сдать квартиру?',
    answer: [
      {
        type: ERowType.String,
        text: 'Это зависит от расположения, района, цены и многого другого. У собственников уходит, в среднем, до 3 месяцев на продажу квартиры и до 1,5 на поиск арендатора. Посмотрите в наших материалах,',
      },
      {
        type: ERowType.Link,
        url: LINK_SELL_FAST,
        text: 'как продать выгоднее',
      },
      {
        type: ERowType.String,
        text: 'или',
      },
      {
        type: ERowType.Link,
        url: LINK_RENT_FAST,
        text: 'сдать быстрее',
      },
    ],
  },
  {
    id: 6,
    question: 'А могу я продать или сдать коммерческую недвижимость?',
    answer: [
      {
        type: ERowType.String,
        text: 'Да, коммерческую тоже',
      },
      {
        type: ERowType.Link,
        url: LINK_SELL_N_RENT,
        text: 'можно продать и сдать:',
      },
      {
        type: ERowType.String,
        text: ' офис, коворкинг, склад, торговую площадь, здание, целое производство, готовый бизнес и даже коммерческую землю. Для этого',
      },
      {
        type: ERowType.Link,
        url: PLACE_AD,
        text: 'разместите объявление',
      },
      {
        type: ERowType.String,
        text: 'с подходящим типом недвижимости.',
      },
    ],
  },
  {
    id: 7,
    question: 'Что делать, если я хочу, чтобы ещё больше людей увидели моё объявление?',
    answer: [
      {
        type: ERowType.Header,
        text: 'Бесплатно',
      },
      {
        type: ERowType.String,
        text: 'Достаточно интересно и подробно рассказать про объект, добавить качественные фото и видео. А за заполнение некоторых полей мы добавим на объявление значки — они привлекут больше внимания.',
      },
      {
        type: ERowType.Header,
        text: 'Платно',
      },
      { type: ERowType.String, text: 'Используйте продвижение' },
      { type: ERowType.Link, url: LINK_POCKETS, text: 'Стандарт, Премиум, Топ' },
      {
        type: ERowType.String,
        text: 'или дополнительную ставку выше Топа. У каждого способа есть свои преимущества: чем дороже — тем выше будет объявление в поиске и тем больше получит просмотров и звонков',
      },
    ],
  },
  {
    id: 8,
    question: 'Я боюсь, что мне будут звонить мошенники, что делать?',
    answer: [
      {
        type: ERowType.String,
        text: 'Мы покажем в объявлении временный номер вместо реального:',
      },
      {
        type: ERowType.List,
        rows: [
          [{ type: ERowType.String, text: 'ваш номер не попадёт в базы мошенников и спам-базы;' }],
          [{ type: ERowType.String, text: 'вам будут звонить, только пока объявление опубликовано.' }],
        ],
      },
      {
        type: ERowType.String,
        text: 'Если вы собираетесь сдать квартиру, можно получать анкеты вместо звонков ',
      },
      {
        type: ERowType.Tooltip,
        title:
          'Анкеты от жильцов в аренде пока только в регионах: Москва и область, Санкт-Петербург и область, Краснодарский край, Нижегородская область, Ростовская область, Самарская область, Свердловская область, Татарстан.',
      },
      {
        type: ERowType.String,
        text: '. Для этого при публикации объявления выберите «Скрыть номер телефона». Потенциальные жильцы заполнят небольшую анкету-заявку и смогут связаться с вами только после одобрения анкеты в личном кабинете. Читайте подробнее, как подключить анкеты.',
      },
    ],
  },
];
